<template>
  <transition leave-active-class="duration-200">
    <div
      v-if="show"
      class="fixed inset-0 bottom-0 z-50 flex items-center justify-center px-4"
    >
      <transition
        enter-active-class="duration-300 ease-out"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-200 ease-in"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="show"
          class="fixed inset-0 transition-opacity"
        >
          <div
            class="absolute inset-0 z-50 backdrop-blur-sm"
            :class="theme === 'dark' ? 'bg-dark-500/25' : 'bg-dark-500/50'"
            @click="$emit('close')"
          />
        </div>
      </transition>

      <slot
        name="outerClose"
        @click="$emit('close')"
      />

      <transition
        enter-active-class="duration-300 ease-out"
        enter-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
        enter-to-class="translate-y-0 opacity-100 sm:scale-100"
        leave-active-class="duration-200 ease-in"
        leave-class="translate-y-0 opacity-100 sm:scale-100"
        leave-to-class="translate-y-4 opacity-0 sm:translate-y-0 sm:scale-95"
      >
        <div
          v-if="show"
          :class="width"
          class="z-50 overflow-x-auto transition-all transform rounded-lg shadow-xl"
          style="max-height: 95vh"
        >
          <slot
            name="innerClose"
            @click="$emit('close')"
          />

          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup>
import { onUnmounted, watch } from 'vue'

const props = defineProps({
  show: {
    type: Boolean,
    required: true
  },
  theme: {
    type: String,
    default: 'light'
  },
  width: {
    type: String,
    default: 'w-full'
  }
});
watch(() => props.show, (newValue) => {
  if (newValue) {
    document.body.classList.add('overflow-hidden');
  } else {
    document.body.classList.remove('overflow-hidden');
  }
});

onUnmounted(() => {
  document.body.classList.remove('overflow-hidden');
});
</script>
